export default __webpack_public_path__ + "static/media/homeBanner.75776a1b.svg";